import type {PickupEligibility} from '@pocketbuy/outdoor-business-types';
import {Button,Card} from '@pocketbuy/outdoor-design-system';

export function PickupRestriction({eligibility,warehouse=false,onView,onReceive,showPhones=false,onPhone}:{
  eligibility?:PickupEligibility|null; warehouse?:boolean; onView?:()=>void; onReceive?:()=>void;
  showPhones?:boolean; onPhone?:(id:number)=>void;
}) {
  if(!eligibility || eligibility.allowed)return null;
  const count=eligibility.overdueCount;
  return <section className="pb-stack" aria-label="Pickup restriction">
    <div className="op-notice pb-stack" role="status">
      <strong>{warehouse?'Pickup unavailable':`${count} phone${count===1?'':'s'} overdue`}</strong>
      <p>{warehouse?`This agent has ${count} overdue phone${count===1?'':'s'}. Receive the returned phones before completing this pickup.`:'Return overdue phones before picking up more.'}</p>
      {onView&&<button type="button" className="op-link" onClick={onView}>View overdue phones</button>}
      {onReceive&&<Button className="secondary" onClick={onReceive}>Receive unsold phone</Button>}
    </div>
    {showPhones&&<OverduePickupPhones eligibility={eligibility} onPhone={onPhone}/>}
  </section>;
}

export function OverduePickupPhones({eligibility,onPhone}:{eligibility:PickupEligibility;onPhone?:(id:number)=>void}) {
  return <div className="pb-stack">{eligibility.overduePhones.map(phone=><Card className="pb-stack" key={phone.deviceId}>
    <div className="pb-stack">
      <strong>{phone.skuName}</strong>
      {phone.imeis.map((item,index)=><small className="pb-muted" key={item.imei}>IMEI {index+1}: {item.imei}</small>)}
      <small className="op-stock-shortage">Overdue · Due {new Intl.DateTimeFormat('en-GB',{timeZone:phone.timeZone,day:'numeric',month:'short',year:'numeric'}).format(new Date(phone.salesDueAt))}</small>
    </div>
    <div><strong>Return to {phone.stockPointName}</strong>{phone.stockPointAddress&&<p className="pb-muted">{phone.stockPointAddress}</p>}</div>
    {onPhone&&<button type="button" className="op-link" onClick={()=>onPhone(phone.deviceId)}>View phone</button>}
  </Card>)}</div>;
}
